import { getCompanyConfigData } from '../company/service';
import { USER_TYPE } from '../../utils/constants/user';
import { toast } from 'react-toastify';
import {
    callEditUser,
    fetchAllUser,
    fetchAllUsersUnified,
    fetchAmlPepData,
    fetchAvailableDebtProducts,
    fetchAvailableProducts,
    fetchCityNames,
    fetchCompanySector,
    fetchOrgBasedUsers,
    getAllInvestmentPreferenceData,
    getCombinedOrgUsers,
    getCombinedDealUsers,
    getFormerEntityName,
    getInvestmentReportService,
    getNotificationTemplate,
    sendSystemNotification,
    verifyWebsite,
    EditUserV2Payload,
    editUserV2,
    getDealsByStatus,
    getMandateQualificationChecks,
    BulkAddPayload,
    bulkAddService,
} from './service';
import { moveCompanyToNewTier } from './investorApiHelper';
import { JAVA_API_STATUS } from '../../utils/axios-interceptor';
import { GENERIC_ERROR } from '../../modules/Company/UploadJourney/components/GstFetch/GSTModal/Context/GstContext';
import { getLookalikesService, recomputeLookalikesService } from './service';
import { FetchOrgBasedUsersPayload } from './action';

export async function getPartnetConfigDataAndSetFormData(payload, handlers) {
    try {
        const configResponse = await getCompanyConfigData({
            accountType: USER_TYPE.PARTNER,
            investorOrgId: payload.investorOrgId,
            primaryEmail: payload.primaryEmail,
            configName: 'AICA_PARTNER_SIGNUP_ADDITIONAL_DETAILS',
        });
        const configData = configResponse?.data?.mainConfig;
        const additionalDetailsConfig = configData?.additionalDetailsConfig;
        if (configData && additionalDetailsConfig) handlers?.onSuccess?.(configData);
        else {
            handlers?.onError?.();
        }
    } catch (error) {
        handlers?.onError?.();
    }
}

export async function getDealFormConfig(payload, handlers) {
    try {
        const configResponse = await getCompanyConfigData({
            accountType: payload.accountType,
            investorOrgId: payload.investorOrgId,
            primaryEmail: payload.primaryEmail,
            configName: payload.configName,
            step: payload.step,
        });
        const configData = configResponse?.data?.mainConfig;
        const additionalDetailsConfig = configData?.additionalDetailsConfig;
        const organizationName = configResponse?.data?.organizationName;
        const displayOrgName = configResponse?.data?.organizationDisplayName;
        if (configData && additionalDetailsConfig) handlers?.onSuccess?.(additionalDetailsConfig, organizationName, displayOrgName);
        else {
            handlers?.onError?.();
        }
    } catch (error) {
        handlers?.onError?.();
    }
}

export async function EditUser(payload) {
    try {
        const response = await callEditUser(payload);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export async function editUserDetailsV2(payload: EditUserV2Payload) {
    try {
        const response = await editUserV2(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data;
        } else {
            toast.error(response.data.responseData.responseMessage || GENERIC_ERROR);
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function getCityNames() {
    try {
        const response = await fetchCityNames();
        return response.data;
    } catch (error) {
        return { error: true };
    }
}

export async function getAllUsers(payload) {
    try {
        const response = await fetchAllUser(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data;
        } else {
            return response.data.responseData.responseMessage;
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function getAllUsersUnified(payload) {
    try {
        const response = await fetchAllUsersUnified(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data;
        } else {
            return response.data.responseData.responseMessage;
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function getOrgBasedUsers(payload: FetchOrgBasedUsersPayload) {
    try {
        const response = await fetchOrgBasedUsers(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data;
        } else {
            return response.data.responseData.responseMessage;
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function fetchCombinedOrgUsers(payload) {
    try {
        const response = await getCombinedOrgUsers(payload);
        if (response?.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            const responseBody = response?.data?.responseBody;
            return {
                currentUsers: responseBody, // Keep existing structure for backward compatibility
                allUsers: responseBody?.allUsers || [], // Add allUsers if available
            };
        } else {
            return {
                currentUsers: {},
                allUsers: [],
            };
        }
    } catch (error) {
        console.error(error);
        return {
            currentUsers: {},
            allUsers: [],
        };
    }
}

export async function fetchCombinedDealUsers(payload) {
    try {
        const response = await getCombinedDealUsers(payload);
        // Handle the new response format for getCombinedDealUsers
        // Response format: { responseBody: { dealUsers: [...], allUsers: [...] } }
        const responseBody = response?.data?.responseBody;
        if (responseBody) {
            return {
                currentUsers: responseBody.dealUsers || [],
                allUsers: responseBody.allUsers || [],
            };
        } else {
            return {
                currentUsers: [],
                allUsers: [],
            };
        }
    } catch (error) {
        console.error('Error fetching combined deal users:', error);
        return {
            currentUsers: [],
            allUsers: [],
        };
    }
}

export async function fetchAllPecData(payload) {
    try {
        const response = await getAllInvestmentPreferenceData(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data.responseBody.data;
        } else {
            toast.error(response.data.responseBody.responseData.responseMessage || GENERIC_ERROR);
            return [];
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function getRiskIndicatorsData(payload) {
    try {
        const response = await fetchAmlPepData(payload);

        if (response?.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data;
        } else {
            toast.error(response.data.responseBody.responseData.responseMessage || GENERIC_ERROR);
            return [];
        }
    } catch (error) {
        console.error(error);
        toast.error(GENERIC_ERROR);
        return [];
    }
}

export async function getFormerEntityData(payload, handlers) {
    try {
        const response = await getFormerEntityName(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            const data = response?.data?.responseBody?.['UW_FORMER_ENTITY_NAME']?.data || {};
            handlers?.onSuccess?.(data);
        } else {
            handlers?.onError?.(response.data);
        }
        return response.data;
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function getDealsByStatusData(payload, handlers) {
    try {
        const response = await getDealsByStatus(payload);
        if (response?.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            const allDeals = response?.data?.responseBody?.data || [];
            handlers?.onSuccess?.(allDeals);
        } else {
            handlers?.onError?.(response.data);
        }
        return response.data;
    } catch (error) {
        handlers?.onError?.();
        console.error(error);
        return {};
    }
}

export async function getMandateQualificationChecksData(payload, handlers) {
    try {
        const response = await getMandateQualificationChecks(payload);
        if (response?.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            handlers?.onSuccess?.(response.data.responseBody || {});
        } else {
            handlers?.onError?.();
        }
    } catch (error) {
        console.error(error);
        handlers?.onError?.();
    }
}

export async function fetchAllAvailableProducts(payload, isDebtProducts = false) {
    try {
        let response = isDebtProducts ? await fetchAvailableDebtProducts(payload) : await fetchAvailableProducts(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data.responseBody.data;
        } else {
            toast.error(response.data.responseBody.responseData.responseMessage || GENERIC_ERROR);
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function getWebsiteVerification(payload) {
    try {
        const response = await verifyWebsite(payload);
        const { responseData, responseBody } = response?.data || {};

        if (responseData?.responseCode === JAVA_API_STATUS.ERROR) {
            toast.error(GENERIC_ERROR);
            return {};
        }

        const fusionData = responseBody?.['FUSION_WEBSITE_VERIFICATION'];
        if (fusionData?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return fusionData.data || {};
        } else {
            toast.error(GENERIC_ERROR);
            return {};
        }
    } catch (error) {
        toast.error(GENERIC_ERROR);
        return {};
    }
}

export async function fetchCompanySectorsList() {
    try {
        const response = await fetchCompanySector();
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return response.data.responseBody;
        } else {
            toast.error(response.data.responseBody.responseData.responseMessage || GENERIC_ERROR);
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function fetchSectorOptions(handlers: { onSuccess: (sectors: { value: string; label: string }[]) => void }) {
    try {
        const response = await fetchCompanySector();
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            const positiveSectors = response.data.responseBody?.AICA_GET_COMPANY_SECTOR_LIST?.data?.positiveSector ?? [];
            const sectors = positiveSectors.map((s: any) => ({ value: s._id ?? '', label: s.label ?? '' }));
            handlers.onSuccess(sectors);
        } else {
            toast.error(response.data.responseBody.responseData.responseMessage || GENERIC_ERROR);
        }
    } catch (error) {
        console.error(error);
    }
}

export async function getInvestmentReport(payload, handlers) {
    try {
        const response = await getInvestmentReportService(payload);
        const responseData = response?.data?.responseData;
        if (responseData?.responseCode === 20) {
            handlers?.onSuccess?.(response?.data || {});
            return response.data;
        } else {
            handlers?.onError?.(response?.data || {});
            return response.data.responseData.responseMessage;
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function sendEmailNotification(payload, handlers) {
    try {
        const response = await sendSystemNotification(payload);
        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            handlers?.onSuccess?.(response.data);
        } else {
            handlers?.onError?.(response.data);
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export async function getEmailTemplate(payload) {
    try {
        const response = await getNotificationTemplate(payload);
        return response;
    } catch (error) {
        console.error(error);
        return {};
    }
}
export const moveTierAndUnlockAICAReport = (orgId: string, tierName: string, investorOrgId: string, onSuccess: Function) => {
    moveCompanyToNewTier({
        assesseeOrgId: orgId,
        inviteType: tierName,
        investorOrgId: investorOrgId,
    })
        .then(() => {
            onSuccess?.();
        })
        .catch((err) => {
            toast.error('Error in unlocking report.');
            console.error('Error in unlocking report', err);
        });
};

export async function sendBulkAddNotification(payload: BulkAddPayload) {
    try {
        const response = await bulkAddService(payload);

        if (response.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            toast.success('This may take up to 2 business hours to get all the leads added into the system.');
            return response.data;
        } else {
            toast.error(response.data.responseData.responseMessage || GENERIC_ERROR);
            return {};
        }
    } catch (error) {
        console.error(error);
        toast.error(GENERIC_ERROR);
        return {};
    }
}

// ── Lookalike helpers ────────────────────────────────────────────────────────

export interface LookalikeRow {
    orgId: string;
    orgName: string;
    leadStatus: string;
    relationshipStatus: string;
    revenue: number | null;
    ebitdaPct: number | null;
    existingDebt: number | null;
    investors: string | null;
    equityRaised: number | null;
    sector: string;
    subSector?: string | null;
    state: string | null;
    bureauScore: string | null;
    similarityRank: number;
    similarityScore: number;
    similarityConfidence: number;
}

export interface LookalikeData {
    status: 'success' | 'empty' | 'error';
    reason?: string;
    message?: string;
    source?: LookalikeRow;
    lookalikes?: LookalikeRow[];
}

export async function fetchLookalikes(orgId: string): Promise<LookalikeData | null> {
    try {
        const response = await getLookalikesService(orgId);
        const data = response?.data?.responseBody;
        if (!data) return null;
        if (data.status === 'empty') return { status: 'empty', reason: data.reason };
        if (data.status === 'error') return { status: 'error', message: data.message || 'Failed to load similar companies' };
        if (data.status !== 'success') return null;
        return { status: 'success', source: data.source, lookalikes: data.lookalikes || [] };
    } catch (err) {
        console.error('Error fetching lookalikes:', err);
        return { status: 'error', message: 'Failed to load similar companies' };
    }
}

export async function triggerRecompute(orgId: string): Promise<boolean> {
    try {
        const response = await recomputeLookalikesService(orgId);
        return response?.status === 200;
    } catch (err) {
        console.error('Error triggering recompute:', err);
        return false;
    }
}
